import { getUrlParams, cookieToJson, setMediaLen } from "../../../js/util";
import { post, get } from "../../../js/http";
import storage from "good-storage";
$(document).ready(function () {
  layui.use(["form", "layer", "flow", "element"], function () {
    var $ = layui.jquery,
      form = layui.form,
      layer = layui.layer,
      flow = layui.flow,
      element = layui.element;
    let pUserId;
    if (storage.get("userInfo")) {
      pUserId = storage.get("userInfo").UserID;
    }
    // 消费明细
    flow.load({
      elem: "#consumption-con", //指定列表容器
      done: function (page, next) {
        //到达临界点（默认滚动触发），触发下一页
        post("/ApiHome/ApiAction?_ControlName=GetUserMoneyDetailByPC", {
          UserID: pUserId,
          PageIndex: page,
          PageSize: 10,
          IsUseFull: 1,
          IsVersion: 0,
        }).then((res) => {
          res.Data["type"] = 0;
          let detailsLoopTpl = require("./detailsLoopList.art");
          var detailsLoopHtml = detailsLoopTpl(res.Data);
          next(detailsLoopHtml, page < Math.ceil(res.Data.TotalRowCount / 10));
        });
      },
      end: "没有更多了",
    });
    getTiXianList({ UserID: pUserId });

    $(".p-account-nav li").click(function () {
      var index = $(this).index();
      $($(".p-account-nav li")[index])
        .addClass("active")
        .siblings()
        .removeClass("active");
      $($(".p-account-content .p-account-content-item")[index])
        .addClass("active")
        .siblings()
        .removeClass("active");
      switch (index) {
        case 0:
          // getUserAccount({
          //   UserID: pUserId
          // });
          break;
        case 1:
          getFreeTime();
          break;
        case 2:
          getCoupon({ UserID: pUserId });
          break;
        case 3:
          getBankCardInfo({ UserID: pUserId });
          break;
        case 4:
          break;
        default:
          break;
      }
    });
    function getFreeTime() {
      post("/ApiHome/ApiAction?_ControlName=GetUserFreeCallInfoByPC").then(
        (res) => {
          if (res.ReturnStatus) {
            let freeCallTimeTemp = require("./freeCallTime/freeCallTime.art");
            let freeCallTimeHtml = freeCallTimeTemp(res.Data);
            $("#freeCallTime").html(freeCallTimeHtml);
            element.render();
            // 免费时长说明
            getFreeTimeTip();
          }
        }
      );

      function getFreeTimeTip() {
        post("/ApiHome/ApiAction?_ControlName=GetInformationConfigByPC", {
          KeyName: "FreeTime",
        }).then((res) => {
          if (res.ReturnStatus) {
            let aboutusStr = res.Data.InfoConfig.KeyValue;
            $(".publicPop-content-con").html(aboutusStr);
            $("#freeTimeTip").off("click");
            $("#freeTimeTip").click(function () {
              let aggrementLayer = layer.open({
                type: 1,
                skin: "layer-custom",
                area: ["600px", ""],
                title: "",
                id: "publicPopCon",
                closeBtn: 0,
                content: $("#publicPop"),
                end: function () {
                  $("#publicPop").hide();
                },
              });
              $("#publicPop .icon-close").click(function () {
                layer.close(aggrementLayer);
              });
            });
          }
        });
      }
    }

    function getUserAccount(data) {
      post("/ApiHome/ApiAction?_ControlName=GetUserAccountInfoByPC", data).then(
        (res) => {
          if (res.ReturnStatus) {
            console.log(res);
          }
        }
      );
    }
    function getCoupon(data) {
      post(
        "/ApiHome/ApiAction?_ControlName=GetUserFreeTicketListByPC",
        data
      ).then((res) => {
        if (res.ReturnStatus) {
          let couponListTemp = require("./coupon/coupon.art");
          let couponListHtml = couponListTemp({
            couponList: res.Data.OnlyOneData,
          });
          $("#couponCon").html(couponListHtml);
          $(".useCoupon").off("click");
          $(".useCoupon").click(function () {
            getFreeCall();
          });
        }
      });
      function getFreeCall() {
        var page = 1;
        getCallService(page);
        function getCallService(page) {
          post("/ApiHome/ApiAction?_ControlName=GetUserCallService", {
            PageIndex: page,
            Position: 1001,
            PositionType: 1004,
            Sex: 0,
            MinAge: -1,
            MaxAge: -1,
            MinFeeAmount: -1,
            MaxFeeAmount: -1,
            PageSize: 6,
          }).then((res) => {
            res.Data.OnlyOneData.forEach((item) => {
              if (item.MediaLength) {
                item.transMediaLength = setMediaLen(item.MediaLength);
              }
            });
            let experiTemplate = require("./coupon/couponExperienceList.art");
            var experiHtml = experiTemplate(res.Data);
            $("#couponExp-con").html(experiHtml);

            layer.open({
              type: 1,
              skin: "layer-custom",
              btnAlign: "c",
              area: ["600px", ""],
              title: "",
              id: "couponExp",
              closeBtn: 2,
              content: $("#couponExp-con"),
              end: function () {
                $("#couponExp-con").hide();
              },
            });
            $("#couponExp-con #changeAnother").off("click");
            $("#couponExp-con #changeAnother").click(function () {
              if (res.Data.OnlyOneData.length == 6) {
                getCallService(++page);
              } else {
                getCallService((page = 1));
              }
            });
          });
        }
      }
    }

    function getBankCardInfo(data) {
      post("/ApiHome/ApiAction?_ControlName=GetUserAccountInfoByPC", data).then(
        (res) => {
          if (res.ReturnStatus) {
            let bankcardTemp = require("./bankcard/bankcard.art");

            let bankNum = res.Data.BankInfo.BankCardNum,
              bankAccountNum = res.Data.BankInfo.BankAccountName;
            var reg = /^(\d{4})\d+(\d{4})$/;
            if (bankNum) {
              bankNum = bankNum.replace(reg, "$1 **** **** $2");
              res.Data.BankInfo.BankCardNum = bankNum.replace(/(.{4})/g, "$1");
            }
            if (bankAccountNum) {
              res.Data.BankInfo.BankAccountName =
                new Array(bankAccountNum.length).join("*") +
                bankAccountNum.substr(-1);
            }
            let bankcardHtml = bankcardTemp(res.Data);
            console.log($("#bankcardCon"));
            console.log(bankcardHtml);
            $("#bankcardCon").html(bankcardHtml);
            getProvinceCity();
            getBankList();
            // 绑定银行卡
            $("#bindCardBtn").click(function () {
              requestBindCard();
            });
            // 更换银行卡
            $("#changeCardBtn").click(function () {
              requestChangeCard();
            });
          }
        }
      );
      function requestBindCard() {
        if (
          pUserId &&
          $("#bankName").val() &&
          $("#bankCode").val() &&
          $("#openUserName").val() &&
          $("select[name=mpprovince]").val() &&
          $("select[name=mpcity]").val() &&
          $("#openBankName").val()
        ) {
          postBindRequest();
        } else {
          layer.msg("请完善银行卡资料", function () {});
        }
        function postBindRequest() {
          let postData = {
            UserID: pUserId,
            PackName: "CallMe.PC",
            BankName: $("#bankName").val(), //开户银行名称
            BankCardNum: $("#bankCode").val(), //银行卡号
            BankAccountName: $("#openUserName").val(), //开户人姓名
            Pid: $("select[name=mpprovince]").val(),
            Cid: $("select[name=mpcity]").val(),
            BranchName: $("#openBankName").val(),
          };
          post(
            "/ApiHome/ApiAction?_ControlName=UploadBankDataByPC",
            postData
          ).then((res) => {
            if (res.ReturnStatus) {
              layer.msg(res.MessageCN, { icon: 1 });
              setTimeout(() => {
                location.reload();
              }, 1500);
            } else {
              layer.msg(res.MessageCN, { icon: 2 });
            }
          });
        }
      }
      function requestChangeCard() {
        let bankcardTemp = require("./bankcard/bankcard.art");
        let bankcardHtml = bankcardTemp({ BankBindStatus: -1 });
        $("#bankcardCon").html(bankcardHtml);
        getProvinceCity();
        getBankList();
        // 绑定银行卡
        $("#bindCardBtn").click(function () {
          requestBindCard();
        });
      }
      function getProvinceCity() {
        //获取省份
        getProvince();

        form.on("select(mpprovince)", function (data) {
          getCity({ ProvinceID: data.value });
        });

        function getProvince() {
          post("/ApiHome/ApiAction?_ControlName=GetCountryProvinceByPc").then(
            (res) => {
              if (res.ReturnStatus) {
                let provinceStr = "";
                res.Data.OnlyOneData.forEach((item, index) => {
                  provinceStr +=
                    "<option value=" +
                    item.AutoID +
                    ">" +
                    item.ProvinceShortName +
                    "</option>";
                });
                $("form select[name='mpprovince']").html(provinceStr);
                form.render("select");
                if ($("select[name=mpprovince]").val()) {
                  getCity({ ProvinceID: $("select[name=mpprovince]").val() });
                }
              }
            }
          );
        }
        function getCity(data) {
          post("/ApiHome/ApiAction?_ControlName=GetCountryCityByPc", data).then(
            (res) => {
              if (res.ReturnStatus) {
                let cityStr = "";
                res.Data.OnlyOneData.forEach((item, index) => {
                  cityStr +=
                    "<option value=" +
                    item.AutoID +
                    ">" +
                    item.CountryShortName +
                    "</option>";
                });
                $("form select[name='mpcity']").html(cityStr);
                form.render("select");
              }
            }
          );
        }
      }
      function getBankList() {
        post("/ApiHome/ApiAction?_ControlName=GetBKListByPC").then((res) => {
          if (res.ReturnStatus) {
            let bankListStr = "";
            res.Data.OnlyOneData.list.forEach((item, index) => {
              bankListStr +=
                "<option value=" + item.Name + ">" + item.Name + "</option>";
            });
            $("form select[name='bankName']").html(bankListStr);
            form.render("select");
          }
        });
      }
    }

    function getTiXianList(data) {
      post("/ApiHome/ApiAction?_ControlName=GetUserAccountInfoByPC", data).then(
        (res) => {
          if (res.ReturnStatus) {
            let tixianTemp = require("./tixian/tixian.art");
            let bankNum = res.Data.BankInfo.BankCardNum;
            var reg = /^(\d{4})\d+(\d{4})$/;
            if (bankNum) {
              bankNum = bankNum.replace(reg, "$1 **** **** $2");
              res.Data.BankInfo.BankCardNum = bankNum.replace(/(.{4})/g, "$1");
            }
            let tixianHtml = tixianTemp({
              bankInfo: res.Data,
            });
            $("#tixianCon").html(tixianHtml);
            if (res.Data.BankBindStatus == 1) {
              // 已绑定银行卡
              //注释提现明细
              // getTixianDetailList();
            }
            // 提现
            $("#tixianBtn").click(function () {
              if ($(".tixianAmount").val()) {
                requestTixian();
              }
            });
            $("#txdes").click(function () {
              getTixianRule();
            });
            // 绑定
            $("#bindBtn").click(function () {
              $($(".p-account-nav li")[3])
                .addClass("active")
                .siblings()
                .removeClass("active");
              $($(".p-account-content .p-account-content-item")[3])
                .addClass("active")
                .siblings()
                .removeClass("active");
              getBankCardInfo({ UserID: pUserId });
            });
          }
        }
      );
      function getTixianDetailList() {
        // 提现明细
        flow.load({
          elem: "#tixiandetail-con", //指定列表容器
          done: function (page, next) {
            //到达临界点（默认滚动触发），触发下一页
            post(
              "/ApiHome/ApiAction?_ControlName=GetUserCashWithdrawListByPC",
              {
                UserID: pUserId,
                PageIndex: page,
                PageSize: 10,
              }
            ).then((res) => {
              res.Data["type"] = 1;
              let detailsLoopTpl = require("./detailsLoopList.art");
              var detailsLoopHtml = detailsLoopTpl(res.Data);
              next(
                detailsLoopHtml,
                page < Math.ceil(res.Data.TotalRowCount / 10)
              );
            });
          },
          end: "没有更多了",
        });
      }

      function requestTixian() {
        post("/ApiHome/ApiAction?_ControlName=UploadWithdrawCashByPC", {
          UserID: pUserId,
          money: $(".tixianAmount").val(),
        }).then((res) => {
          if (res.ReturnStatus) {
            layer.msg(res.MessageCN, { icon: 1 });
          } else {
            layer.msg(res.MessageCN, { icon: 2 });
          }
        });
      }
      function getTixianRule() {
        let data = {
          PackName: "CallMe.PC",
          RuleKey: "WalletTakeMoneyRule",
        };
        post("/ApiHome/ApiAction?_ControlName=GetGoPageRuleByPC", data).then(
          (res) => {
            if (res.ReturnStatus) {
              window.open(res.Data.Url, "_blank");
            }
          }
        );
      }
    }

    let audioSetInterval;
    window.playVoice = function (el) {
      window.clearInterval(audioSetInterval);
      SetTimeL();
      let vblist = $(".voice-box");

      if (el.getAttribute("data-media") == $("#audioPlayer").attr("src")) {
        //同一个音频
        if ($(el).hasClass("pause")) {
          $(el).removeClass("pause").addClass("playing");
          $("#audioPlayer")[0].play();
          audioSetInterval = setInterval(Func, 1000);
        } else {
          $(el).removeClass("playing").addClass("pause");
          $("#audioPlayer")[0].pause();
        }
      } else {
        $(el).removeClass("pause").addClass("playing");
        $("#audioPlayer").attr("src", el.getAttribute("data-media"));
        $("#audioPlayer")[0].play();
        audioSetInterval = setInterval(Func, 1000);
      }
      if (vblist.length) {
        for (var i = 0; i < vblist.length; i++) {
          if (
            vblist[i].getAttribute("data-media") !=
            $("#audioPlayer").attr("src")
          ) {
            $(vblist[i]).removeClass("playing").addClass("pause");
          }
        }
      }

      function Func() {
        // 创建倒计时
        if (vblist.length) {
          for (var i = 0; i < vblist.length; i++) {
            if ($(vblist[i]).hasClass("playing")) {
              // 设置剩余时长
              let temp = Number(
                $(vblist[i]).find("label.timeL").attr("data-ctime")
              );
              if (temp - 1 >= 0) {
                $(vblist[i])
                  .find("label.timeL")
                  .attr("data-ctime", temp - 1);
                $(vblist[i])
                  .find("label.timeL")
                  .text(setMediaLen(temp - 1));
              }
            }
          }
        }
      }

      function SetTimeL() {
        let vblist = $(".voice-box");
        if (vblist.length) {
          for (var i = 0; i < vblist.length; i++) {
            $(vblist[i])
              .find("label.timeL")
              .text(setMediaLen(vblist[i].getAttribute("data-time")));
          }
        }
      }
      var audio = document.getElementById("audioPlayer");
      if (audio) {
        audio.loop = false;
        audio.addEventListener(
          "ended",
          function () {
            console.log("结束");
            SetTimeL();
            //清除倒计时
            window.clearInterval(audioSetInterval);
            let vblist = $(".voice-box");
            if (vblist.length) {
              for (var i = 0; i < vblist.length; i++) {
                if (
                  vblist[i].getAttribute("data-media") ==
                  $("#audioPlayer").attr("src")
                ) {
                  $(vblist[i]).removeClass("playing").addClass("pause");
                }
              }
            }
            //在这个方法里写相应的逻辑就可以了
          },
          false
        );
      }
    };
  });
});
